var BaseViews = require('../base');
var StringUtils = require('../../utils/strings');
var CartErrorMessage = require('./cart-review/cart-error-message');
var CreditCardForm = require('./cart-payment/forms/credit-card-form');
var CustomerEntities = require('../../entities/customer');

require('./cart-payment/cart-payment.scss');
require('./cart-payment/credit-card-sprites/sprites.scss');

var CartPayment = BaseViews.LayoutView.extend({
    className: 'fmcy-cart-payment',
    template: require('./cart-payment/cart-payment.html'),
    initialize: function(options) {
        var self = this;
        this.options = _.defaults(
            options || {},
            {
                theme: 'light',
                errors: null,
                errorMessage: null,
                errorField: null,
                _appChannel: null
            }
        );
        this.currentOrderModel = this.options._appChannel.request('cart:get:curent:order');
        this.cartCost = this.currentOrderModel.get('order_total');
    },
    serializeData: function () {
      return {
        cartTotalCost: StringUtils.currency(this.cartCost),
        orderCode: this.currentOrderModel.get('order_code'),
        paymentMethod: this.currentOrderModel.get('order_payment_method')
      }
    },
    ui: {
      cartTotalCost: '.fmcy-cart-payment-total-cost',
      cartLeftColumn: '.fmcy-cart-payment-left-column',
      cartRightColumn: '.fmcy-cart-payment-right-column'
    },
    regions: {
        errorMessageRegion: '.fmcy-cart-payment-error-message-region',
        paymentFormRegion: '.fmcy-cart-payment-pay-form-region'
    },
    _renderErrorMessage: function () {
      var errorMessageOptions = {};
      if (this.options.errorMessage !== null) {
        errorMessageOptions.message = this.options.errorMessage;
      }
      this._errorMessage = new CartErrorMessage(errorMessageOptions);
      this.errorMessageRegion.show(this._errorMessage);
    },
    _renderCreditCardPaymentForm() {
      this._creditCardForm = new CreditCardForm({
          _appChannel: this.options._appChannel,
          errorField: this.options.errorField,
          model: this.options._appChannel.request('cart:get:payment:method:model')
      });
      this.paymentFormRegion.show(
        this._creditCardForm
      );
    },
    _hideErrorMessage: function () {
      this.options.errors = [];
      this.options.errorMessage = null;
      this.errorMessageRegion.empty();
    },
    onRender: function() {
      var self = this;

      if (this.options.errors && this.options.errors.length > 0) {
        this._renderErrorMessage();
        this.options._appChannel.request('scroll:to:page:top');
      }
      
      if (this.currentOrderModel.get('order_payment_method') === 'credit') {
        this._renderCreditCardPaymentForm();
      }


      $(window).on('resize.' + this.cid, _.bind(this._onWindowResize, this));

      this._onWindowResize();

      this.listenTo(this.options._appChannel, 'cart:pay', function () {
        self._hideErrorMessage();
      });

      BaseViews.LayoutView.prototype.onRender.call(self);
    },
    _onWindowResize: function (event) {
      var magicBuffer = 132;
      var minHeight = $(window).height() - magicBuffer;
      this.$el.css('minHeight', minHeight);
      this.ui.cartLeftColumn.css('minHeight', minHeight);
      this.ui.cartRightColumn.css('minHeight', minHeight);
    },
    onDestroy: function () {
      $(window).off('resize.' + this.cid);
      BaseViews.LayoutView.prototype.onDestroy.call(self);
    }
});

module.exports = CartPayment;



/** WEBPACK FOOTER **
 ** ./assets/js/common/cart/cart-payment.js
 **/